// @ts-nocheck
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductQuantityOrdered from "@insite/content-library/Components/ProductQuantityOrdered";
import { TextFieldProps } from "@insite/mobius/TextField";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

// Starter Custom Code - >
import translate from "@insite/client-framework/Translate";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
// <--- Starter Custom Code

type Props = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState, ownProps: HasProduct) => ({
    configurationSelection: state.pages.productDetails.configurationSelection,
    configurationCompleted: state.pages.productDetails.configurationCompleted,
    variantSelectionCompleted: state.pages.productDetails.variantSelectionCompleted,
});

export interface ProductDetailsQuantityOrderedStyles {
    quantityOrdered?: TextFieldProps;
}

export const quantityOrderedStyles: ProductDetailsQuantityOrderedStyles = {
    quantityOrdered: {
        cssOverrides: {
            formField: css`
                display: flex;
                /* bunzl deleted code */
                /* Bunzl custom code */
                width: ${pxToRem(66)};
            `,
            formInputWrapper: css`
                margin-top: 0 !important; /* not overridable... */
                /* Bunzl custom code */
                width: 100%;
            `,
            inputSelect: css`
                text-align: center;
                /* Bunzl custom code */
                height: ${pxToRem(42)};
                /* bunzl custom code */
                min-width: ${pxToRem(50)};
            `,
        },

        labelProps: {
            css: css`
                width: auto;
                ${({ theme }) => `
                
                    font-size: ${theme.design.typography.size.smallest}; /* bunzl custom code */
                    font-weight: ${theme.design.typography.weight.bold};
                `}
            `,
        },
    },
};

const styles = quantityOrderedStyles;

const ProductDetailsQuantityOrdered = ({
    configurationSelection,
    configurationCompleted,
    variantSelectionCompleted,
}: Props) => {
    return (
        <ProductQuantityOrdered
            configurationSelection={configurationSelection}
            configurationCompleted={configurationCompleted}
            variantSelectionCompleted={variantSelectionCompleted}
            extendedStyles={styles.quantityOrdered}
            data-test-selector="productDetails_quantityOrderedInput" /* Store Custom Code */
            // Starter Custom Code
            aria-label={translate("Quantity")}
        />
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(connect(mapStateToProps)(ProductDetailsQuantityOrdered)),
    definition: {
        displayName: "Quantity Ordered",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
